import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useCallback } from 'react';

import { adminActions } from '../admin.slice';
import { useAppDispatch } from 'src/app/store/hooks';

export function KinetikSettingsRouteActions() {
  const dispatch = useAppDispatch();

  const handleAddKinetikSettings = useCallback(() => {
    dispatch(adminActions.setShowKinetikSettingsModal(true));
  }, [dispatch]);

  return (
    <div className="flex flex-row gap-2">
      <Button onClick={handleAddKinetikSettings} variant="primary">
        Add Kinetik Settings
      </Button>
    </div>
  );
}
